import { useCallback, useState } from 'react';
import type { RootState } from '@store/root-reducer';

import { REDIRECT_DELAY_MS } from './constants';

type SdkOptions = NonNullable<RootState['docsVerification']['sdkOptions']>;

export const useFinishRedirect = (sdkOptions?: SdkOptions) => {
    const [timeToRedirect, setTimeToRedirect] = useState(REDIRECT_DELAY_MS);

    const redirectToLink = useCallback(() => {
        if (
            sdkOptions?.redirectUrl ||
            sdkOptions?.settings?.finish_screen_settings?.redirect_link
        ) {
            window.location.href =
                (sdkOptions.redirectUrl as string) ??
                sdkOptions?.settings?.finish_screen_settings?.redirect_link;
        }
    }, [sdkOptions?.settings?.finish_screen_settings?.redirect_link, sdkOptions?.redirectUrl]);

    const startRedirectTimer = useCallback(() => {
        let time = timeToRedirect;

        const checkTime = () => {
            if (time === 0) {
                redirectToLink();
            } else {
                time -= 1000;
                setTimeToRedirect(time);
            }

            setTimeout(checkTime, 1000);
        };

        setTimeout(checkTime, 1000);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sdkOptions]);

    return {
        timeToRedirect,
        redirectToLink,
        startRedirectTimer,
    };
};
